export default "__VITE_ASSET__c632c0e8__"